import React from 'react';


export class Textarea extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.generateState()
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props !== prevProps) {
            this.setState(this.generateState());
        }
    }

    generateState = () => {
        return {
            color: 'main',
            value: '',
            placeholder: '',
            height: 'auto',
            onChange: (event) => {},
            onKeyDown: (event) => {},
            onBlur: (event) => {},
            ...this.props
        };
    }

    render() {
        return (
            <textarea
                className={'imd-form-control imd-text-' + this.state.color}
                style={{height: this.state.height}}
                value={this.state.value}
                placeholder={this.state.placeholder}
                onChange={(event) => this.state.onChange(event)}
                onKeyDown={(event) => this.state.onKeyDown(event)}
                onBlur={(event) => this.state.onBlur(event)}
            />
        );
    }
}
